import { SELF, TODAY } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { getSafeDateTime } from 'helpers/date';
import { DateModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { DeepSafePartial } from 'types/types';
import { IdentificationDateOfBirthModel } from './types';
import dateModelValidator from '../../../shared/validators/models/date/date';

function getAge(Date: DeepSafePartial<DateModel>) {
  const date = getSafeDateTime(Date);
  if (date.valid === false) { return {}; }
  // https://moment.github.io/luxon/docs/manual/math.html#losing-information
  return TODAY.diff(date.datetime, 'years').years;
}

const identificationDateOfBirthValidator: ValidateJSModel<IdentificationDateOfBirthModel> = {
  Date: (value, attributes, attributeName, options) => {
    if (attributes?.Date) {
      const age = getAge(attributes?.Date);
      let ageError = 'error.birthdate.age.max';
      let latestDate = (!!attributes?.Confirmed && attributes?.Confirmed.checked === true) || isPVQForm(options?.formType) ? undefined : SELF.latest;

      // Alternate case: Age is in the future
      if (age < 0.0) {
        ageError = 'error.birthdate.age.future';
        latestDate = TODAY;
      }

      return {
        presence: true,
        date: {
          earliest: SELF.earliest,
          latest: latestDate,
          validator: dateModelValidator,

          notValid: 'error.date.invalid',
          tooLate: ageError,
          tooEarly: 'error.birthdate.age.min',
          notLessThan: ageError,
        },
      };
    }
    return { presence: true };
  },
  Confirmed: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    if (attributes?.Date) {
      const age = getAge(attributes?.Date);

      if (age <= 0.0) {
        return {
          presence: true,
          model: {
            validator: {
              checked: {
                requireTrue: {
                  message: 'error.birthdate.age.future',
                },
              },
            },
          },
        };
      }
      if (age < 16.0) {
        return {
          presence: true,
          model: {
            validator: {
              checked: {
                requireTrue: {
                  message: 'error.birthdate.age.max',
                },
              },
            },
          },
        };
      }
      return {};
    }
    return {};
  },
  EstimatedDateOfBirthExplanation: (value, attributes, attributeName, options) => (
    isPVQForm(options?.formType) && attributes?.Date?.estimated ? { presence: true, hasValue: true } : {}
  )
};

export default identificationDateOfBirthValidator;
